<template>
  <a-card :bordered="false" :headStyle="{fontSize:'18px'}">
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="分类名称" v-bind="searchItemLayout">
            <a-input v-model="queryParams.categoryName" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item style="margin-left:20px;">
            <a-button type="primary" @click="searchBtn">查询</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <a-button type="primary" @click="onShowModal" icon="plus">新建</a-button>
    <custom-paging-dragging-list
      ref="table"
      rowKey="id"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
      @draggable="onDraggable"
    >
      <div slot="indexSlots" slot-scope="rowItem">{{ rowItem.index + 1 }}</div>
      <div slot="action" slot-scope="rowItem">
        <a @click="handleContent(rowItem.record.id)">编辑</a>
        <span v-if="rowItem.record.type!==1">
          <a-divider type="vertical"/>
        <a-popconfirm
          title="你确定要删除这行内容吗?"
          @confirm="deleteEvent(rowItem.record)">
          <a>删除</a>
        </a-popconfirm>
        </span>
        <a-divider type="vertical"/>
        <a v-if="rowItem.record.status === 0" @click="updateStatus(rowItem.record.id,1)">显示</a>
        <a v-else @click="updateStatus(rowItem.record.id,0)">隐藏</a>
      </div>
    </custom-paging-dragging-list>
    <a-modal
      title="新建分类"
      :width="666"
      v-model="visible"
      @ok="submitEvent"
      @cancel="onCancel"
    >
      <a-form-model
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol">
        <a-form-model-item label="分类名称" prop="contentName">
          <a-input placeholder="请输入" v-model="ruleForm.contentName" :maxLength="6" style="max-width: 300px;"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import searchForm from '../../../../utils/mixins/searchFormMixins'
import CustomPagingDraggingList from '@/customComponents/CustomPagingDraggingList/CustomPagingDraggingList'

export default {
  name: 'ContentCategory',
  mixins: [searchForm],
  components: {
    CustomPagingDraggingList
  },
  data() {
    return {
      queryParams: {},
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      staffStatusList: [],
      visible: false,
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'indexSlots' }
        },
        {
          title: '分类ID',
          dataIndex: 'id'
        },
        {
          title: '分类名称',
          dataIndex: 'contentName'
        },
        {
          title: '状态',
          dataIndex: 'statusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      ruleForm: {
        contentName: ''
      },
      rules: {
        contentName: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      loadPromise: params => this.getListPromise(params),
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      id: '',
      requestId: ''
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ContentList', title: '内容列表' },
      { name: 'ContentCategory', title: '内容分类' },
      { name: 'Introduction', title: '景区介绍' },
      { name: 'ScenicAreaDynamic', title: '景区动态' }
    ])
  },
  methods: {
    updateStatus(id, type) {
      let params = {
        status: type,
        merchantId: this.merchantId,
        platformId: this.platformId,
        id: id
      }
      this.getHttpServices().getServerApiService().post('advice/category/status', params)
        .then(res => {
          this.$refs.table.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    searchBtn() {
      this.$refs.table.refresh()
    },
    onDraggable(params) {
      let idList = []
      idList = params.dataList.map((item) => {
        return item.id
      })
      let data = {
        pageNum: params.pageNo,
        pageSize: params.pageSize,
        idList: idList,
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      this.getHttpServices().getServerApiService().post('advice/category/adjust/sort', data)
        .then(res => {
          this.$message.success('排序成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    deleteEvent(record) {
      this.getHttpServices().getServerApiService().post('/advice/category/delete/' + record.id + '/' + this.merchantId + '/' + this.platformId)
        .then(res => {
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getListPromise(params) {
      params.merchantId = this.merchantId
      params.platformId = this.platformId
      return this.getHttpServices().getServerApiService().post('advice/category/list', params)
    },
    onShowModal() {
      this.id = ''
      this.ruleForm.contentName = ''
      this.visible = true
      this.requestId = Date.parse(new Date())
    },
    handleContent(id) {
      this.id = id
      this.visible = true
      this.requestId = Date.parse(new Date())
      this.getCategoryInfo(id)
    },
    getCategoryInfo(id) {
      let url = 'advice/category/' + id
      this.getHttpServices().getServerApiService().post(url)
        .then(res => {
          this.ruleForm.contentName = res.contentName
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    submitEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    onCancel() {
      this.visible = false
    },
    submitData() {
      let params = {
        contentName: this.ruleForm.contentName,
        merchantId: this.merchantId,
        platformId: this.platformId,
        id: this.id,
        requestId: this.requestId
      }
      this.getHttpServices().getServerApiService().post('advice/category/save', params)
        .then(res => {
          this.$refs.table.refresh()
          this.visible = false
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>

<style lang="less" scoped>

</style>